var React = require('react');

function TickOutlineInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"current","strokeWidth":"2","strokeLinejoin":"round","strokeLinecap":"round","d":"M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"}));
}

TickOutlineInline.defaultProps = {"className":"h-6 w-6 font-bold planet:text-white text-yellow-lighten","fill":"none","viewBox":"0 0 24 24"};

module.exports = TickOutlineInline;

TickOutlineInline.default = TickOutlineInline;
